import { render, staticRenderFns } from "./OliverSettings.vue?vue&type=template&id=1bfcb100"
import script from "./OliverSettings.vue?vue&type=script&lang=js"
export * from "./OliverSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports